import Dashboard from './Dashboard';
//sets the pages display settings
import AuthGuard from '../AuthGuard';

// Wrapper estable para evitar que el layout al re-renderizar (p. ej. resize) monte de nuevo el Dashboard
function DashboardRoute() {
  return AuthGuard(<Dashboard />);
}

const DashboardConfig = {
  settings: {
    layout: {
      style: 'layout1',
    },
  },
  routes: [
    {
      path: '/dashboard',
      component: DashboardRoute,
    },
  ],
};

export default DashboardConfig;
